import * as Scrivito from "scrivito";
import { useMobileNavigation } from "^/Context/MobileNavigationContext";
import { isLiv } from "^/utils/isLiv";
import getHomepage from "../../utils/getHomepage";
import MobileUserNav from "./Mobile/MobileUserNav";
import MobileNavBar from "./Mobile/MobileNavBar";
import MobileNavigation from "./Mobile/MobileNavigation";
import MobileSearchField from "./Mobile/MobileSearchField";

function Mobile() {
  const { showSearch, showNavigation, showUserNavigation } =
    useMobileNavigation();
  const currentPage = Scrivito.currentPage();
  const homepage = getHomepage(currentPage);
  if (!homepage) {
    return null;
  }
  const lang = currentPage.language();
  const searchResultsPage = homepage.get("searchPage");
  return (
    <div
      className="fixed-bottom bg-white shadow-up d-block d-md-none"
      id="mobil-navigation"
    >
      <MobileNavigation
        currentPage={currentPage}
        lang={lang}
        homepage={homepage}
        show={showNavigation}
      />
      {!isLiv(currentPage) && (
        <MobileSearchField
          searchResultsPage={searchResultsPage}
          show={showSearch}
        />
      )}
      <MobileUserNav show={showUserNavigation} />
      <MobileNavBar />
    </div>
  );
}

export default Scrivito.connect(Mobile);
